import {
  BonusPayableMonth,
  BonusStatByMonth,
  BonusStats,
  BonusStatusByMonth,
  DisplayableType,
  IDayDetail,
  IDriverStats,
  OptInStatus,
} from '@app/core/model/qualifications.model';
import { IBonusQualificationService } from '../interface/IBonusQualificationService';

export class MockBonusQulificationService implements IBonusQualificationService {
  constructor() {}

  getBonusPayableMonths(driverCode: string): Promise<BonusPayableMonth[]> {
    const promise = new Promise<BonusPayableMonth[]>((resolve, reject) => {
      resolve([]);
    });
    return promise;
  }

  getBonusStatusByMonth(driverCode: string, month: Date): Promise<BonusStatByMonth> {
    const now = new Date();
    const promise = new Promise<BonusStatByMonth>((resolve, reject) => {
      if (month >= new Date(now.getFullYear(), now.getMonth(), 1)) {
        resolve({
          name: 'Current_OnTrack',
          icon: 'thumbs-up',
          heading: 'Keep it up!',
          description:
            'Based on your latest September performance you are on track to earn 2% out of a possible 4% on trips dispatched in October. Keep up the great work!',
          payAmount: 0.02,
        });
      } else {
        resolve({
          name: 'Previous_AtRisk',
          icon: 'exclamation-triangle',
          heading: 'At Risk!',
          description:
            'ACT NOW! You are at risk of missing out on part of your bonus! We show you are not current on your commitments, huddles, or safety video. Your [qualifyPeriod] performance can qualify you to earn up to [potentialBonus] on trips dispatched in [payPeriod][splitifteam]. View the Stats tab above for more details on your performance.',
          payAmount: 0,
        });
      }
    });
    return promise;
  }

  getBonusStatus(
    driverCode: string,
    displayableType: DisplayableType
  ): Promise<BonusStatusByMonth[]> {
    const promise = new Promise<BonusStatusByMonth[]>((resolve, reject) => {
      resolve([
        {
          month: new Date(2020, 6, 1),
          description: 'Bonus on July Trips',
          stats: {
            qualifyPeriod: new Date(2020, 6, 1),
            monthProgress: 100,
            accidentCount: 0,
            criticalEventCount: 0,
            lateArrivalCount: 0,
            safetyVideoCompletion: 0,
            safetyVideoNotAssigned: false,
            finalSafetyBonus: false,
            finalSafetyBonusText: 'Missed',
            finalOnTimeBonus: false,
            finalOnTimeBonusText: 'Missed',
            finalCommitBonus: false,
            finalTotalBonus: 0,
            lastUpdatedDate: null,
            commitmentStats: [],
            wigAttendanceCounts: 0,
            wigAttendanceDenominator: 0,
          },
        },
        {
          month: new Date(2020, 7, 1),
          description: 'Bonus on August Trips',
          stats: {
            qualifyPeriod: new Date(2020, 7, 1),
            monthProgress: 100,
            accidentCount: 0,
            criticalEventCount: 0,
            lateArrivalCount: 0,
            safetyVideoCompletion: 0,
            safetyVideoNotAssigned: false,
            finalSafetyBonus: false,
            finalSafetyBonusText: 'Missed',
            finalOnTimeBonus: false,
            finalOnTimeBonusText: 'Missed',
            finalCommitBonus: false,
            finalTotalBonus: 0,
            lastUpdatedDate: null,
            commitmentStats: [],
            wigAttendanceCounts: 0,
            wigAttendanceDenominator: 0,
          },
        },
        {
          month: new Date(2020, 8, 1),
          description: 'Bonus on September Trips',
          stats: {
            qualifyPeriod: new Date(202, 8, 1),
            monthProgress: 74.19,
            accidentCount: 0,
            criticalEventCount: 0,
            lateArrivalCount: 0,
            safetyVideoCompletion: 0,
            safetyVideoNotAssigned: false,
            finalSafetyBonus: false,
            finalSafetyBonusText: 'Missed',
            finalOnTimeBonus: false,
            finalOnTimeBonusText: 'Missed',
            finalCommitBonus: false,
            finalTotalBonus: 0,
            lastUpdatedDate: null,
            commitmentStats: [],
            wigAttendanceCounts: 0,
            wigAttendanceDenominator: 0,
          },
        },
        {
          month: new Date(2020, 9, 1),
          description: 'Bonus on October Trips',
          stats: {
            qualifyPeriod: new Date(2020, 9, 1),
            monthProgress: -26.67,
            accidentCount: 0,
            criticalEventCount: 0,
            lateArrivalCount: 0,
            safetyVideoCompletion: 0,
            safetyVideoNotAssigned: false,
            finalSafetyBonus: false,
            finalSafetyBonusText: 'Missed',
            finalOnTimeBonus: false,
            finalOnTimeBonusText: 'Missed',
            finalCommitBonus: false,
            finalTotalBonus: 0,
            lastUpdatedDate: null,
            commitmentStats: [],
            wigAttendanceCounts: 0,
            wigAttendanceDenominator: 0,
          },
        },
        {
          month: new Date(2020, 10, 1),
          description: 'Bonus on November Trips',
          stats: {
            qualifyPeriod: new Date(2020, 10, 1),
            monthProgress: -122.58,
            accidentCount: 0,
            criticalEventCount: 0,
            lateArrivalCount: 0,
            safetyVideoCompletion: 0,
            safetyVideoNotAssigned: false,
            finalSafetyBonus: false,
            finalSafetyBonusText: 'Missed',
            finalOnTimeBonus: false,
            finalOnTimeBonusText: 'Missed',
            finalCommitBonus: false,
            finalTotalBonus: 0,
            lastUpdatedDate: null,
            commitmentStats: [],
            wigAttendanceCounts: 0,
            wigAttendanceDenominator: 0,
          },
        },
      ]);
    });
    return promise;
  }

  getCommitmentDetails(
    driverId: string,
    leadSubject: string,
    startdaysAgo: number,
    endDaysAgo: number
  ): Promise<IDayDetail[]> {
    const promise = new Promise<IDayDetail[]>((resolve, reject) => {
      resolve([
        {
          date: new Date(2020, 8, 20),
          status: 'No',
          driverDailyLeadId: 584633,
          leadId: 1,
          isDayOf: false,
          leadQuestions: null,
        },
        {
          date: new Date(2020, 8, 21),
          status: 'Not Applicable',
          driverDailyLeadId: 0,
          leadId: 1,
          isDayOf: false,
          leadQuestions: null,
        },
        {
          date: new Date(2020, 8, 22),
          status: 'Not Applicable',
          driverDailyLeadId: 0,
          leadId: 1,
          isDayOf: false,
          leadQuestions: null,
        },
        {
          date: new Date(2020, 8, 23),
          status: 'Not Applicable',
          driverDailyLeadId: 0,
          leadId: 1,
          isDayOf: false,
          leadQuestions: null,
        },
        {
          date: new Date(2020, 8, 24),
          status: 'Not Applicable',
          driverDailyLeadId: 0,
          leadId: 1,
          isDayOf: false,
          leadQuestions: null,
        },
        {
          date: new Date(2020, 8, 25),
          status: 'Not Applicable',
          driverDailyLeadId: 0,
          leadId: 1,
          isDayOf: false,
          leadQuestions: null,
        },
        {
          date: new Date(2020, 8, 26),
          status: 'Not Applicable',
          driverDailyLeadId: 0,
          leadId: 1,
          isDayOf: false,
          leadQuestions: null,
        },
      ]);
    });
    return promise;
  }

  getCommitmentDetailsByLeadId(driverId: string, leadId: number): Promise<IDayDetail[]> {
    const promise = new Promise<IDayDetail[]>((resolve, reject) => {
      resolve([
        {
          date: new Date(2020, 8, 20),
          status: 'No',
          driverDailyLeadId: 584633,
          leadId: 1,
          isDayOf: false,
          leadQuestions: null,
        },
        {
          date: new Date(2020, 8, 21),
          status: 'Not Applicable',
          driverDailyLeadId: 0,
          leadId: 1,
          isDayOf: false,
          leadQuestions: null,
        },
        {
          date: new Date(2020, 8, 22),
          status: 'Not Applicable',
          driverDailyLeadId: 0,
          leadId: 1,
          isDayOf: false,
          leadQuestions: null,
        },
        {
          date: new Date(2020, 8, 23),
          status: 'Not Applicable',
          driverDailyLeadId: 0,
          leadId: 1,
          isDayOf: false,
          leadQuestions: null,
        },
        {
          date: new Date(2020, 8, 24),
          status: 'Not Applicable',
          driverDailyLeadId: 0,
          leadId: 1,
          isDayOf: false,
          leadQuestions: null,
        },
        {
          date: new Date(2020, 8, 25),
          status: 'Not Applicable',
          driverDailyLeadId: 0,
          leadId: 1,
          isDayOf: false,
          leadQuestions: null,
        },
        {
          date: new Date(2020, 8, 26),
          status: 'Not Applicable',
          driverDailyLeadId: 0,
          leadId: 1,
          isDayOf: false,
          leadQuestions: null,
        },
      ]);
    });
    return promise;
  }

  getDisplayableStats(driverCode: string, qualifyPeriod: string): Promise<BonusStats> {
    const promise = new Promise<BonusStats>((resolve, reject) => {
      resolve({
        qualifyPeriod: new Date(2020, 8, 1),
        monthProgress: 61.29,
        accidentCount: 0,
        criticalEventCount: 0,
        lateArrivalCount: 0,
        safetyVideoCompletion: 0.0,
        safetyVideoNotAssigned: false,
        finalSafetyBonus: true,
        finalSafetyBonusText: 'On Track',
        finalOnTimeBonus: true,
        finalOnTimeBonusText: 'On Track',
        finalCommitBonus: false,
        finalTotalBonus: 2,
        lastUpdatedDate: new Date(2020, 8, 20, 11, 28, 53),
        commitmentStats: [
          {
            commitmentCount: 0,
            commitmentDenominator: 1,
            leadSubject: 'Creep Mode',
          },
          {
            commitmentCount: 0,
            commitmentDenominator: 1,
            leadSubject: 'G.O.A.L.',
          },
        ],
        wigAttendanceCounts: 2,
        wigAttendanceDenominator: 2,
      });
    });
    return promise;
  }

  getDriverStats(driverId: string): Promise<IDriverStats[]> {
    const promise = new Promise<IDriverStats[]>((resolve, reject) => {
      resolve([
        {
          qualifyPeriod: new Date(2020, 6, 1),
          monthProgress: 0.0,
          accidentCount: 0,
          criticalEventCount: 1,
          lateArrivalCount: 0,
          safetyVideoCompletion: 0.0,
          safetyVideoNotAssigned: false,
          finalSafetyBonus: false,
          finalSafetyBonusText: 'Missed',
          finalOnTimeBonus: true,
          finalOnTimeBonusText: 'On Track',
          finalCommitBonus: false,
          commitBonusPercentage: 0.0,
          finalCommitBonusText: null,
          finalTotalBonus: 1,
          dvirCount: 1,
          paperworkCount: 2,
          csaViolationCount: 3,
          logViolationCount: 4,
          lastUpdatedDate: new Date(2020, 7, 31, 23, 30),
          commitmentStats: [
            {
              commitmentCount: 0,
              commitmentDenominator: 23,
              leadSubject: 'No Distracted Driving',
              leadId: 5,
            },
            {
              commitmentCount: 0,
              commitmentDenominator: 23,
              leadSubject: 'Trip Plan',
              leadId: 6,
            },
          ],
          wigAttendanceCounts: 4,
          wigAttendanceDenominator: 4,
        },
        {
          qualifyPeriod: new Date(2020, 7, 1),
          monthProgress: 0.0,
          accidentCount: 0,
          criticalEventCount: 0,
          lateArrivalCount: 0,
          safetyVideoCompletion: 100.0,
          safetyVideoNotAssigned: false,
          finalSafetyBonus: true,
          finalSafetyBonusText: 'On Track',
          finalOnTimeBonus: true,
          finalOnTimeBonusText: 'On Track',
          finalCommitBonus: false,
          commitBonusPercentage: 0.0,
          finalCommitBonusText: null,
          finalTotalBonus: 2,
          dvirCount: 1,
          paperworkCount: 2,
          csaViolationCount: 3,
          logViolationCount: 4,

          lastUpdatedDate: new Date(2020, 8, 22, 23, 30),
          commitmentStats: [
            {
              commitmentCount: 1,
              commitmentDenominator: 24,
              leadSubject: 'No Distracted Driving',
              leadId: 5,
            },
            {
              commitmentCount: 0,
              commitmentDenominator: 24,
              leadSubject: 'Trip Plan',
              leadId: 6,
            },
          ],
          wigAttendanceCounts: 5,
          wigAttendanceDenominator: 5,
        },
        {
          qualifyPeriod: new Date(2020, 8, 1),
          monthProgress: 0.0,
          accidentCount: 0,
          criticalEventCount: 0,
          lateArrivalCount: 0,
          safetyVideoCompletion: 0.0,
          safetyVideoNotAssigned: false,
          finalSafetyBonus: true,
          finalSafetyBonusText: 'On Track',
          finalOnTimeBonus: true,
          finalOnTimeBonusText: 'On Track',
          finalCommitBonus: false,
          commitBonusPercentage: 0.0,
          finalCommitBonusText: null,
          finalTotalBonus: 2,
          dvirCount: 1,
          paperworkCount: 2,
          csaViolationCount: 3,
          logViolationCount: 4,
          lastUpdatedDate: new Date(2020, 8, 26, 23, 30, 3),
          commitmentStats: [
            {
              commitmentCount: 0,
              commitmentDenominator: 16,
              leadSubject: 'No Distracted Driving',
              leadId: 5,
            },
            {
              commitmentCount: 2,
              commitmentDenominator: 16,
              leadSubject: 'Trip Plan',
              leadId: 6,
            },
          ],
          wigAttendanceCounts: 4,
          wigAttendanceDenominator: 4,
        },
      ]);
    });
    return promise;
  }

  getDriverStatsByQualifyPeriod(
    driverId: string,
    qualifyPeriod: Date,
    includeBonusData: boolean
  ): Promise<IDriverStats> {
    const promise = new Promise<IDriverStats>((resolve, reject) => {
      resolve({
        qualifyPeriod: new Date(2020, 6, 1),
        monthProgress: 0.0,
        accidentCount: 0,
        criticalEventCount: 1,
        lateArrivalCount: 0,
        safetyVideoCompletion: 0.0,
        safetyVideoNotAssigned: false,
        finalSafetyBonus: false,
        finalSafetyBonusText: 'Missed',
        finalOnTimeBonus: true,
        finalOnTimeBonusText: 'On Track',
        finalCommitBonus: false,
        commitBonusPercentage: 0.0,
        finalCommitBonusText: null,
        finalTotalBonus: 1,
        dvirCount: 1,
        paperworkCount: 2,
        csaViolationCount: 3,
        logViolationCount: 4,
        lastUpdatedDate: new Date(2020, 7, 31, 23, 30),
        commitmentStats: [
          {
            commitmentCount: 0,
            commitmentDenominator: 23,
            leadSubject: 'No Distracted Driving',
            leadId: 5,
          },
          {
            commitmentCount: 0,
            commitmentDenominator: 23,
            leadSubject: 'Trip Plan',
            leadId: 6,
          },
        ],
        wigAttendanceCounts: 4,
        wigAttendanceDenominator: 4,
      });
    });
    return promise;
  }

  getOptInDetails(driverCode: string): Promise<OptInStatus> {
    const promise = new Promise<OptInStatus>((resolve, reject) => {
      resolve({
        driver: 'MARGEG',
        profileStatus: null,
        startDate: new Date(2020, 6, 1),
        expirationDate: new Date(2049, 12, 31),
        status: 'Live',
      });
    });
    return promise;
  }

  optInDriver(driverCode: string, startDate: string): Promise<string> {
    const promise = new Promise<string>((resolve, reject) => {
      resolve(null);
    });
    return promise;
  }
}
